<mobi-breadcrumb />
<mobi-hero-text
  [title]="entity().title"
  [superTitle]="entity().superTitle"
  [subtitle]="formattdedDate()"
  [lead]="entity().lead"
/>
<div class="page-content">
  <mobi-content-section width="sm" [content]="body">
    <ng-template #body>
      <mobi-text [data]="entity().body" class="mobi-pr-text text-read block" />
    </ng-template>
  </mobi-content-section>
  <mobi-content-section width="sm" [content]="prImages">
    <ng-template #prImages>
      @if (entity().images) {
        @if ((entity().images?.length ?? 0) <= 1) {
          @for (
            image of entity().images;
            track image?.uuid ?? $index;
            let index = $index
          ) {
            @defer (hydrate never) {
              <mobi-media
                [entity]="image"
                rounded="full"
                [showDescription]="true"
                [showDownload]="true"
              />
            }
          }
        }
        @if (entity().images!.length > 1) {
          <mobi-gallery [images]="entity()!.images!" />
        }
      }
    </ng-template>
  </mobi-content-section>
  @defer (hydrate on viewport) {
    @if (entity().relatedContent?.length) {
      <div class="content-section is-background">
        <div>
          <mobi-related-content
            [teasers]="entity().relatedContent!"
            [title]="entity().relatedContentTitle"
            [description]="entity().relatedContentText"
          />
        </div>
      </div>
    }
  }

  <div class="content-section is-background">
    <div>
      <mobi-concierge />
    </div>
  </div>
</div>
